import { render } from "./OptionsView.vue?vue&type=template&id=234250bd&scoped=true&ts=true"
import script from "./OptionsView.vue?vue&type=script&lang=ts"
export * from "./OptionsView.vue?vue&type=script&lang=ts"

import "./OptionsView.vue?vue&type=style&index=0&id=234250bd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234250bd"]])

export default __exports__